import Notifications from './Notifications';
import config from '@/config/config';

const MESSAGES = {
  INVALID_SERVER_RESPONSE: 'Invalid Server Response',
  NOT_AUTHORIZED: 'You are not authorized to access this page, please login and try again.',
  TITLE: 'Unauthorized',
};

export default class AuthResponse {
  /**
   *
   * @param res
   * @param dispatch
   * @param commit
   * @param rootState
   * @returns {boolean|Promise}
   */
  static async validate(res, { dispatch = null, commit = null, rootState = null }) {
    if (!AuthResponse.isValid(res, dispatch)) {
      return false;
    }

    const response = await res.json();

    if (!response) {
      return false;
    }

    if (response.detail) {
      // commit('ui/addError', response.detail, { root: true });
      Notifications.error(response.detail);
      return false;
    }

    if (Array.isArray(response)) {
      const messages = response.map(item => {
        if (item.message) {
          return item.message;
        }
      }).join('<br />');
      Notifications.error(messages);
      return false;
    }

    return response;
  }

  static isValid(res, dispatch) {
    if (!res || !res.status) {
      Notifications.error(
        MESSAGES.INVALID_SERVER_RESPONSE,
        () => dispatch(`${config.app}/logout`, {}, { root: true }),
        MESSAGES.TITLE
      );
      return false;
    }

    switch (res.status) {
      case 401: // Unauthorized
      case 403: // Forbidden
        Notifications.error(
          res.statusText || MESSAGES.NOT_AUTHORIZED,
          () => dispatch(`${config.app}/logout`, {}, { root: true }),
          MESSAGES.TITLE
        );
        return false;
    }

    return true;
  }
}
